var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.getStatusText(_vm.device)),function(state){return _c('v-chip',{key:state,class:`ma-1 ` + _vm.getColorConnected(_vm.device),attrs:{"label":""}},[_vm._v(" "+_vm._s(state)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }